// extracted by mini-css-extract-plugin
export default {"root":"MapSwitcher_root__MBRXX","icon":"MapSwitcher_icon__VR3o8","pd":"MapSwitcher_pd__0e0q1","mapLg":"MapSwitcher_mapLg__CjiaA"};